import { ACCESSORIES_PROCESS_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE, ACCESSORIES_PROCESS_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB, ACCESSORIES_PROCESS_DC_USERFORM_RESET, CREATE_ACCESSORIES_PROCESS_DC_FAILURE, CREATE_ACCESSORIES_PROCESS_DC_REQUEST, CREATE_ACCESSORIES_PROCESS_DC_SUCCESS, CREATE_USER_FORM_ACCESSORIES_PROCESS_DC, DELETE_ACCESSORIES_PROCESS_DC_FAILURE, DELETE_ACCESSORIES_PROCESS_DC_REQUEST, DELETE_ACCESSORIES_PROCESS_DC_SUCCESS, FETCH_ACCESSORIES_PROCESS_DC_FAILURE, FETCH_ACCESSORIES_PROCESS_DC_INVOICE_FAILURE, FETCH_ACCESSORIES_PROCESS_DC_INVOICE_REQUEST, FETCH_ACCESSORIES_PROCESS_DC_INVOICE_SUCCESS, FETCH_ACCESSORIES_PROCESS_DC_REQUEST, FETCH_ACCESSORIES_PROCESS_DC_SUCCESS, FETCH_ACCESSORIES_PROCESS_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS, FETCH_SINGLE_ACCESSORIES_PROCESS_DC_FAILURE, FETCH_SINGLE_ACCESSORIES_PROCESS_DC_REQUEST, FETCH_SINGLE_ACCESSORIES_PROCESS_DC_SUCCESS, NAVIGATE_ACCESSORIES_PROCESS_DC, NAVIGATE_ACCESSORIES_PROCESS_DC_DETAILS, RESET_ACCESSORIES_PROCESS_DC_INVOICE, SET_GRID_PAGE_INDEX_ACCESSORIES_PROCESS_DC, UPDATE_ACCESSORIES_PROCESS_DC_FAILURE, UPDATE_ACCESSORIES_PROCESS_DC_REQUEST, UPDATE_ACCESSORIES_PROCESS_DC_SUCCESS } from "./accessoriesProcessDC.actionsType";


export const ACCESSORIES_PROCESS_DC = 'accessoriesProcessDC';

let initialState = {
    loading: false,
    gridPageIndex: 0,
    accessoriesProcessDC: [],
    accessoriesProcessDCInvoice: [],
    userform: { fldFKDeliveryAt: '', fldFKSupplierID: '', fldStyle: '', fldSaleOrder: '', },
    selectedaccessoriesProcessDC: {},
    isaccessoriesProcessDC: false,
    detailsId: [],
    activeKey: 1,
    accessoriesProcessDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    supplierListBasedOnProgram: [],
};

export let accessoriesProcessDCReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ACCESSORIES_PROCESS_DC_REQUEST:
        case CREATE_ACCESSORIES_PROCESS_DC_REQUEST:
        case FETCH_SINGLE_ACCESSORIES_PROCESS_DC_REQUEST:
        case UPDATE_ACCESSORIES_PROCESS_DC_REQUEST:
        case DELETE_ACCESSORIES_PROCESS_DC_REQUEST:
        case FETCH_ACCESSORIES_PROCESS_DC_INVOICE_REQUEST:
            // case DELETE_BTN_UPDATE_API_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_PROCESS_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesProcessDC: updatePayload
            };
        case CREATE_ACCESSORIES_PROCESS_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' },
                detailsId: updatePayload
            };

        case FETCH_ACCESSORIES_PROCESS_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesProcessDCInvoice: updatePayload
            };
        case FETCH_SINGLE_ACCESSORIES_PROCESS_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedaccessoriesProcessDC: updatePayload,
                userform: updatePayload
            };
        case UPDATE_ACCESSORIES_PROCESS_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedaccessoriesProcessDC: {},
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' },
                detailsId: []
            };
        case DELETE_ACCESSORIES_PROCESS_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' },
                selectedaccessoriesProcessDC: {},
                detailsId: []
            };
        case FETCH_ACCESSORIES_PROCESS_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS:
            return {
                ...state,
                loading: false,
                supplierListBasedOnProgram: updatePayload
            }
        case FETCH_ACCESSORIES_PROCESS_DC_FAILURE:
        case FETCH_SINGLE_ACCESSORIES_PROCESS_DC_FAILURE:
        case CREATE_ACCESSORIES_PROCESS_DC_FAILURE:
        case UPDATE_ACCESSORIES_PROCESS_DC_FAILURE:
        case DELETE_ACCESSORIES_PROCESS_DC_FAILURE:
        case FETCH_ACCESSORIES_PROCESS_DC_INVOICE_FAILURE:
            // case DELETE_BTN_UPDATE_API_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ACCESSORIES_PROCESS_DC:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case SET_GRID_PAGE_INDEX_ACCESSORIES_PROCESS_DC:
            return {
                ...state,
                gridPageIndex: payload
            };
        case ACCESSORIES_PROCESS_DC_USERFORM_RESET:
            return {
                ...state,
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '', fldStyle: '', fldSaleOrder: '', },
                selectedaccessoriesProcessDC: {},
                detailsId: [],
                activeKey: 1
            };
        case RESET_ACCESSORIES_PROCESS_DC_INVOICE:
            return {
                ...state,
                accessoriesPoInvoice: []
            };
        case NAVIGATE_ACCESSORIES_PROCESS_DC_DETAILS:
            return {
                ...state,
                isaccessoriesProcessDC: true,
                loading: false,
                accessoriesProcessDCSelectedValue: updatePayload.accessoriesProcessDCSelectedValue
            };
        case NAVIGATE_ACCESSORIES_PROCESS_DC:
            return {
                ...state,
                isaccessoriesProcessDC: false
            };
        case ACCESSORIES_PROCESS_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: ''
                },
                activeKey: 2
            };
        case ACCESSORIES_PROCESS_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,

                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: ''
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
